import { z } from 'zod'
import { firestoreTimestamp, firestoreWriteTimestamp } from '../shared/schema'

export const schema = z.object({
  productId: z.string(),
  sectionId: z.string(),
  customProduct: z.boolean(),
  userId: z.string(),
  updatedAt: firestoreTimestamp,
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    productId: '',
    sectionId: '',
    customProduct: false,
    userId: '',
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export type FirestoreSectionProduct = z.infer<typeof schema>
export type FirestoreSectionProductWrite = z.infer<typeof writeSchema>
